import React, { useEffect,useState } from "react";
import {
  Grid,
  Box,
  makeStyles,
  Hidden,
  useMediaQuery,
  useTheme,
  Divider,
  Container,
} from "@material-ui/core";
import fly365 from "../../assets/images/fly365.png";
import mIamge from "../../assets/images/mImage.jpg";
import goa from "../../assets/images/goa1.jpg";
import FlightBooking from "../../assets/images/FlightBooking.jpg";
import MSearch from "../../form/MSearch";
import Footer from "./Footer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchFlight from "../../form/SearchFlight";
import MSearchFlight from "../../form/MSearch";
import Carousel from "../../components/reusableComponents/Carousels";
import CarouselBottom from "../../components/reusableComponents/CarouselBottom";
import CarouselInterHoliday from "../../components/reusableComponents/CarouselInterHoliday";
import Currency from "../../components/reusableComponents/Currency";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrencyDispatch } from "../../reducers/HomeReducer";
import { useTranslation } from 'react-i18next'

const languages = [
  { value: '', text: "Options" },
  { value: 'en', text: "English" },
  { value: 'hi', text: "Hindi" },
  { value: 'bn', text: "Bengali" }
]
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    paddingRight: 15,
    paddingLeft: 15,
    marginRight: "auto",
    marginLeft: "auto",
  },
  header: {
    background: "#fff",
    boxShadow: "0px 0px 10px rgb(0 0 0 / 5%)",
  },
  back: {
    backgroundImage: `url(${mIamge})`,

    // backgroundPosition: '1px -241px',
    zIndex: 0,
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    transition: "background-image 300ms ease-in 200ms",
  },
}));
const MHome = () => { 
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const {curr} = useSelector((state)=>state.ui)
  // const {currency} = useSelector((state)=>state.home)
  const { t } = useTranslation(); 
  
    const [lang, setLang] = useState('');
  
    // This function put query that helps to 
    // change the language
    const handleChange = e => { 
        setLang(e.target.value);
        console.log("first",e.target.value)
        let loc = "http://localhost:3000/";
        window.location.replace(loc + "?lng=" + e.target.value);
    }
    const GlobeIcon = ({ width = 24, height = 24 }) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="currentColor"
        className="bi bi-globe"
        viewBox="0 0 16 16"
      >
        <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z" />
      </svg>
    )
  useEffect(()=>{
    dispatch(fetchCurrencyDispatch(curr))
    // const rup = ()=>{
    //   console.log('first', Object.entries(currency.conversion_rates))
    // }
    // rup();
  },[])
  console.log("first")
  return (
    <>
      <Box
        className={classes.container}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems:'center'
        }}
      >
        <Box style={{ paddingBottom: 4.5, paddingTop: 4.5 }}>
          <i class="fas fa-blender-phone"></i>
          <span style={{ color: "#065999", fontSize: 13 }}>1800 8890 743 </span>
          <span style={{ display: "inline-block", width: "1px" }}></span>
          <i class="fa fa-fw fa-envelope"></i>
          <span style={{ color: "#065999", fontSize: 13 }}>info@xyz.com</span>
        </Box>
        <Box display='flex' alignItems='center'
          style={{ paddingBottom: 4.5, paddingTop: 4.5, alignItems: "center" }}
        >
           <Box display='flex'>
        <GlobeIcon />
        <select value={lang} onChange={handleChange}>
                {languages.map(item => {
                    return (<option key={item.value} 
                    value={item.value}>{item.text}</option>);
                })}
            </select>
        </Box>
           <Currency/>
          {/* <i class="fa fa-fw fa-user"></i>
          <span style={{ color: "#065999", fontSize: 16 }}>Login</span> */}
        </Box>
       
        
       
      </Box>
      <header
        className={classes.header}
        style={{ paddingLeft: 20, paddingRight: 20 }}
      >
        <Hidden only={["xs"]}>
          {" "}
          <Box
            className={classes.container}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box display="flex" alignItems="center">
              <img
                src="https://www.marinersforex.com/img/LOGO-MarinersForex.png"
                // src={fly365}
                style={{ height: 50 }}
                // style={{ height: 80,width:80 }}
              />
            </Box>
            <Box>
              <i
                class="fas fa-plane-departure"
                style={{ color: "blue", marginRight: 5 }}
              ></i>
              <span style={{ color: "#0A95FF" }}>Flight</span>
              <span style={{ color: "#0A95FF", marginLeft: 20 }}>
                My Booking
              </span>
            </Box>
          </Box>
        </Hidden>

        <Hidden only={["lg", "xl", "sm", "md"]}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <img
              src="https://www.marinersforex.com/img/LOGO-MarinersForex.png"
              style={{ height: 50 }}
            />
            <div className="icons">
              <div
                className="fas fa-bars"
                id="menu-btn"
                onClick={() => {
                  // let navbar = document.querySelector('.navbar');
                  // navbar.classList.toggle('active');
                  // navbar.classList.add('active');
                }}
              ></div>
            </div>
          </Box>
        </Hidden>
      </header>
      {/* <div
					style={{
						position: 'absolute',
						// top: '0px',
						left: '0px',
						height: '100%',
						width: '100%',
						zIndex: 1,
						background: 'rgb(26, 43, 72)',
						opacity: 0.3,
					}}></div> */}

      <div style={{ position: "relative" }}>
        {/* <div
					style={{
						position: 'absolute',
						top: '0px',
						left: '0px',
						height: '100%',
						width: '100%',
						zIndex: 1,
						background: 'rgb(26, 43, 72)',
						opacity: 0.3,
					}}></div> */}
        <section
          onClick={() => {
            // let loginForm = document.querySelector('.login-form');
            // let navbar = document.querySelector('.navbar');
            // navbar.classList.remove('active');
            // loginForm.classList.remove('active');
          }}
          className={classes.back}
          style={{ height: matches ? 800 : 500 }}
          // data-aos='zoom-in'
        >
          {/* <MSearch /> */}
          {/* <SearchFlight/> */}
          <MSearchFlight />
          <Box display='flex'>
						<div style={{ marginTop: 10, background: '#263a4a' }}>
							<p
								style={{
									color: 'red',
									fontSize: 16,
									fontWeight: 600,
									marginLeft: 5,
								}}>
								HotDeals
							</p>
						</div>
						<marquee>
							<div style={{ marginTop: 10, background: '#263a4a' }}>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
							</div>
						</marquee>
					</Box>
        </section>
      </div>
      {/* <label>{t('Search')}</label> */}

      <Box style={{ padding: 20 }}>
        <h2 style={{color: '#0c2f54',
        
    fontFamily: '"Poppins", sans-serif'}}>{t("hotel")}</h2>
        <span style={{fontFamily: '"Poppins", sans-serif',fontSize:16}}>Enjoy unforgettable experiences in dream hotels worldwide</span>
       <div style={{marginTop:10}}>
	   <Carousel />
	   </div>
      </Box>
      <Grid
        container
        spacing={2}
        style={{ marginTop: matches ? 120 : 50, padding: 20 }}
      >
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Box>
            <Box
              style={{
                position: "relative",
                background: "#e0fff5",
                margin: matches ? 0 : "50px 0px 50px 0px",
                padding: 20,
                borderRadius: 5,
                border: "1px solid rgba(0,0,0,.125)",
              }}
            >
              <h2
                style={{
                  color: "#0c2f54",
                  fontFamily: '"Poppins", sans-serif',
                }}
              >
                Domestic Holidays
              </h2>
              <p>
                Trips to India diverse tourist spots, redefine a new dimension
                of luxury and relaxation
              </p>
            </Box>
          </Box>
        </Grid>
        {[0, 1, 2].map((item) => {
          return (
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Box
                style={{
                  borderRadius: 5,
                  border: "1px solid rgba(0,0,0,.125)",
                }}
              >
                <img src={goa} style={{ height: 200, width: "100%" }} />
                <Box style={{ padding: 10 }}>
                  <p
                    style={{ color: "#343a40", fontWeight: 600, marginTop: 10 }}
                  >
                    Exotic Shimla Manali
                  </p>
                  <p style={{ color: "#6c757d" }}>Starting From ₹18500</p>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <div style={{ padding: 20 }}>
        <h2
          style={{
            color: "#0c2f54",
            fontWeight: 600,
            fontFamily: '"Poppins", sans-serif',
          }}
        >
          Featured Deals
        </h2>
        <p style={{ color: "#0c2f54" }}>Get the Best Deals & Discounts</p>
      </div>
      <Grid container spacing={2} style={{ padding: 20 }}>
        <Grid item xs={12} sm={6} lg={6}>
          <img src={FlightBooking} style={{ width: "100%" }}></img>
        </Grid>
        <Grid item xs={12} sm={6} lg={6}>
          <img src={FlightBooking} style={{ width: "100%" }}></img>
        </Grid>
      </Grid>
      <div
        style={{
          padding: 20,
          boxShadow: "0px 0px 50px -35px rgb(0 0 0 / 40%)",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontWeight: 600,
            color: "#0c2f54",
            fontFamily: '"Poppins", sans-serif',
          }}
        >
          Start your travel planning here
        </h1>
        <Container style={{ marginTop: 20 }}>
          <Grid container spacing={2}>
            {[0, 1, 2, 3, 4, 5].map((i) => {
              return (
                <Grid item xs={12} lg={4} alignItems="center">
                  <Box justifyContent="space-between" display="flex">
                    <Box>
                      <h3>Delhi</h3>
                      <span>
                        <a>Mumbai</a>
                        <a style={{ marginLeft: 5 }}>Bangalore</a>
                        <a style={{ marginLeft: 5 }}>Kolkata</a>
                        <a style={{ marginLeft: 5 }}>Chandigarh</a>
                      </span>
                    </Box>
                    <ExpandMoreIcon />
                  </Box>
                  <Divider style={{ marginTop: 10 }} />
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </div>

      <Container>
        <img
          src="https://www.marinersforex.com/img/Rassia-MF.jpg"
          style={{ width: "100%" }}
        ></img>
        <h2 style={{ fontFamily: '"Poppins", sans-serif', color: "#0c2f54" }}>
          International Holidays
        </h2>
        <p>
          Explore a variety of holiday tour packages and create lasting memories
        </p>
        <CarouselInterHoliday />
      </Container>
      <Container>
        <img
          src="https://www.marinersforex.com/img/about.png"
          style={{ width: "100%" }}
        ></img>
      </Container>
      <Container>
	  <h1
          style={{
            textAlign: "center",
            fontWeight: 600,
            color: "#0c2f54",
            fontFamily: '"Poppins", sans-serif',
          }}
        >
          Travel Blog
        </h1>
		<p style={{
            textAlign: "center",
            fontWeight: 600,
            color: "#0c2f54",
            fontFamily: '"Poppins", sans-serif',
          }}>Explore these places and some other thing here</p>
        <CarouselBottom />
      </Container>
      {/* <Grid container  style={{ padding: 20 }}>
				<Grid item xs={4}></Grid>
				<Grid item xs={4}></Grid>
				<Grid item xs={4}></Grid>
			</Grid> */}
      <Footer />
    </>
  );
};

export default MHome;
